import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import { getThemeClasses } from "../utils/themeClass";

export default function BestMultiplayer() {
  const { theme } = useTheme();
  const themeClass = getThemeClasses(theme);

  return (
    <div className={`${themeClass.bgColor} ${themeClass.baseText} min-h-screen`}>
    <div className={`min-h-screen px-6 py-12 ${themeClass.bgColor} ${themeClass.baseText}`}>
      <Helmet>
        <title>Best Multiplayer Browser Games | BrowserArena</title>
        <meta
          name="description"
          content="Discover the best multiplayer browser games online. Join battles, co-op challenges, and strategy showdowns — all with no downloads on BrowserArena."
        />
        <meta
          name="keywords"
          content="multiplayer browser games, online multiplayer games, play with friends"
        />
        <link rel="canonical" href="https://browserarena.com/best-multiplayer" />
        <meta property="og:title" content="Best Multiplayer Browser Games | BrowserArena" />
        <meta property="og:description" content="Top multiplayer browser games to play instantly — battle royales, co-op puzzles, strategy games and more." />
        <meta property="og:url" content="https://browserarena.com/best-multiplayer" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className={`max-w-4xl mx-auto rounded-2xl border ${themeClass.borderColor} ${themeClass.overlayBg} shadow-xl backdrop-blur-lg p-8`}>
        <h1 className={`text-4xl font-bold mb-6 tracking-wide ${themeClass.titleColor}`}>
          Best Multiplayer Browser Games
        </h1>

        <p className={`text-lg leading-relaxed mb-6 ${themeClass.overlayText}`}>
          Multiplayer browser games have revolutionized online entertainment by bringing people together in virtual arenas, battlefields, and fantasy worlds. These games are designed to be played in real-time with friends or strangers from around the world, offering dynamic gameplay that never gets boring.
        </p>

        <p className={`text-lg leading-relaxed mb-6 ${themeClass.overlayText}`}>
          Popular genres include battle royale, strategy, co-op puzzles, and MMORPGs. Titles like <strong>Krunker.io</strong>, <strong>Shell Shockers</strong>, and <strong>Surviv.io</strong> have taken the multiplayer scene by storm.
        </p>

        <p className={`text-lg leading-relaxed mb-6 ${themeClass.overlayText}`}>
          What sets multiplayer browser games apart is the lack of downloads. You can jump in instantly, making them perfect for spontaneous game nights or quick sessions. Ranking systems and seasonal leaderboards keep things competitive and engaging.
        </p>

        <p className={`text-lg leading-relaxed mb-6 ${themeClass.overlayText}`}>
          These games also foster teamwork, critical thinking, and communication skills. Whether you're defending your base or solving puzzles together, multiplayer browser games offer unmatched social fun.
        </p>

        <p className={`text-lg leading-relaxed mb-8 ${themeClass.overlayText}`}>
          At <strong>BrowserArena</strong>, we’ve curated the best multiplayer games across all styles—from chill to hardcore. Dive in and start playing instantly!
        </p>

        <div className="mt-8 text-center">
          <p className={`text-base mb-4 ${themeClass.overlayText}`}>
            Learn more about{" "}
            <Link to="/about-browser-games" className={`${themeClass.hoverText} underline`}>
              browser games
            </Link>{" "}
            or explore our{" "}
            <Link to="/html5-games" className={`${themeClass.hoverText} underline`}>
              HTML5 games
            </Link>{" "}
            now.
          </p>
          <Link
            to="/games/multiplayer"
            className={`inline-block mt-4 px-6 py-2 text-base font-semibold rounded-full border ${themeClass.borderColor} ${themeClass.overlayText} hover:${themeClass.hoverBorder} hover:${themeClass.hoverText} transition`}
          >
            🎮 Browse All Multiplayer Games
          </Link>
        </div>
      </div>
    </div>
    </div>
  );
}
